import React from 'react';

export const PAYMENT_TERMS = [
  { code: 'contado', label: 'Contado' },
  { code: 'credito_30', label: 'Crédito 30 días' },
  { code: 'credito_45', label: 'Crédito 45 días' },
];

export const paymentTermLabel = (code) =>
  PAYMENT_TERMS.find((row) => row.code === code)?.label || '';

export const partyHint = (item) =>
  [item?.supplier, item?.payment_term_label || paymentTermLabel(item?.payment_term)].filter(Boolean).join(' · ');

export const PartyHint = ({ item, ui }) => {
  const text = partyHint(item);
  if (!text) return null;
  return <div style={{ fontSize: 11, color: ui.muted }}>{text}</div>;
};

export const PartyFields = ({ form, setForm, styles }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
    <label style={styles.label}>
      Proveedor
      <input
        value={form.supplier || ''}
        onChange={(event) => setForm((prev) => ({ ...prev, supplier: event.target.value }))}
        style={styles.input}
        placeholder="Nombre del proveedor"
      />
    </label>
    <label style={styles.label}>
      Forma de pago
      <select
        value={form.payment_term || 'contado'}
        onChange={(event) => setForm((prev) => ({ ...prev, payment_term: event.target.value }))}
        style={styles.input}
      >
        {PAYMENT_TERMS.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  </div>
);
